import angular from 'angular';

// Imported Modules
import componentsButtonModule from './buttons/buttons.module';
import assetListModule from './asset-list/asset-list.module';
import assetSearchModule from './asset-search/asset-search.module';
import tableColumnSelectorModule from './table-column-selector/table-column-selector.module';
import SignoutComponent from './sign-out.component';
import ResolvableGeoLocationComponent from './resolvable-geo-location/resolvable-geo-location.component';

import AutoCompleteDirective from './auto-complete/autoComplete';
import MultiEmailsComponent from './multi-emails/multi-emails';
import ProgressBarComponent from './progress-bar/progress-bar';
import ResponseMessageDirective from './response-message/response-message';
import SearchBarDirective from './search-bar/search-bar';
import SearchableDropdownComponent from './searchable-dropdown/searchable-dropdown';
import SimpleTagsComponent from './simple-tags/simple-tags';
import SparkLineComponent from './spark-line/spark-line';
import StatusBarComponent from './status-bar/status-bar';
import TimeProgressBarComponent from './time-progress-bar/time-progress-bar';
import TransferComponent from './asset-list/transfer.component';

// New imports from Directives folder
import EquipmentStatusComponent from './equipment-status/equipment-status';
import TagUrlComponent from './tag-url/tag-url';
import FieldsRequiredComponent from './fields-required/fields-required';
import LoadingIndicatorComponent from './loading-indicator/loading-indicator';
import ModalDialogComponent from './modal-dialog/modal-dialog';
import SearchableMultiselectComponent from './searchable-multi-select-dropdown/searchable-multi-select-dropdown';
import TopModuleNavComponent from './top_nav/top.nav';
import AssetMultiPickerController from './assetpicker/asset.multi.picker.controller';
import AssetPickerController2 from './assetpicker/asset.picker.controller';

import BrowserUpdateBanner from './browser-update-banner/browserUpdateBanner.component';
import BrowserLinks from './browser-links/browser-links.component';

import PaginationComponent from './pagination/pagination.component';

// Import filters from app.module
import MiliSecondsFormatFilter from './time-progress-bar/filters/milisecondsFormat.filter';
import {
  AlertsBtnGroupComponent,
  AlertsBtnGroupController,
} from './alerts-btn-group/alerts-btn-group.component';
import {
  MaintenanceBtnGroupComponent,
  MaintenanceBtnGroupController,
} from './maintenance-btn-group/maintenance-btn-group.component';
import { ModalComponent, ModalController } from './modal/modal.component';
import { ToolTipComponent, ToolTipController } from './tool-tip/tool-tip.component';
import ZTRDatePickerComponent from './ztr-date-picker/ztr-date-picker.component';
import StepsComponent from './steps/steps.component';
import timezoneSelector from './timezone-selector/timezone-selector';
import lastSeenFilterComponent from './last-seen-filter/last-seen-filter.component';
import CommunicatedAtFilterComponent from './communicated-at-filter/communicated-at-filter.component';

const componentsModule = angular.module('app.components', [
  // INTERNAL
  componentsButtonModule,
  assetListModule,
  assetSearchModule,
  tableColumnSelectorModule,

  // EXTERNAL
  'ui.bootstrap',
  'ui.router',
  'ncy-angular-breadcrumb',
  'gettext',
]);

componentsModule
  // Controllers
  .controller('AlertsBtnGroupController', AlertsBtnGroupController)
  .controller('MaintenanceBtnGroupController', MaintenanceBtnGroupController)
  .controller('ModalController', ModalController)
  .controller('ToolTipController', ToolTipController)

  // Directives
  .directive('autoComplete', AutoCompleteDirective)
  .directive('responseMessage', ResponseMessageDirective)
  .directive('searchBar', SearchBarDirective)
  .directive('simpleTags', SimpleTagsComponent)

  // Components
  .component('multiEmails', MultiEmailsComponent)
  .component('ztrProgressBar', ProgressBarComponent)
  .component('searchableDropdown', SearchableDropdownComponent)
  .component('sparkLine', SparkLineComponent)
  .component('ztrStatusBar', StatusBarComponent)
  .component('timeProgressBar', TimeProgressBarComponent)
  .component('alertsBtnGroup', AlertsBtnGroupComponent)
  .component('maintenanceBtnGroup', MaintenanceBtnGroupComponent)
  .component('modal', ModalComponent)
  .component('ztrToolTip', ToolTipComponent)
  .component('assetTransfer', TransferComponent)
  .component('signout', SignoutComponent)
  .component('resolvableLocation', ResolvableGeoLocationComponent)
  .component('stepsComponent', StepsComponent)

  .controller('AssetMultiPickerController', AssetMultiPickerController)
  .controller('AssetPickerController2', AssetPickerController2)
  .component('browserUpdateBanner', BrowserUpdateBanner)
  .component('browserLinks', BrowserLinks)
  .component('ztrDatePicker', ZTRDatePickerComponent)
  .component('timezoneSelector', timezoneSelector)
  .component('lastSeenFilter', lastSeenFilterComponent)
  .component('communicatedAtFilter', CommunicatedAtFilterComponent)
  .component('zPagination', PaginationComponent)

  // Directives moved from directives folder
  .directive('equipmentStatus', EquipmentStatusComponent)
  .directive('tagUrl', TagUrlComponent)
  .directive('fieldsRequired', FieldsRequiredComponent)
  .directive('loadingIndicator', LoadingIndicatorComponent)
  .directive('modalDialog', ModalDialogComponent)
  .directive('searchableMultiselect', SearchableMultiselectComponent)
  .directive('topModuleNav', TopModuleNavComponent)

  // Filters
  .filter('millisecondsFormat', MiliSecondsFormatFilter);
export default componentsModule.name;
